import { changeForgotPassword } from '@/dataProvider/authDataProvider/changeForgotPassword';
import { changePassword } from '@/dataProvider/authDataProvider/changePassword';
import { forgotPassword } from '@/dataProvider/authDataProvider/forgotPassword';

export const authDataProvider = {
  changePassword: changePassword,
  changeForgotPassword: changeForgotPassword,
  forgotPassword: forgotPassword,
};
